import { useEffect, useState } from "react";
import { useSettingsController } from "../controller";
import { SettingsCard } from "./SettingsCard";
import { SettingsItem } from "./SettingsItem";

export const BuildiumIntegration = () => {
  const { currentSettings, updateSettings } = useSettingsController();
  const [editMode, setEditMode] = useState(false);
  const [buildiumClientId, setBuildiumClientId] = useState("");
  const [buildiumClientSecret, setBuildiumClientSecret] = useState("");
  const settings = currentSettings.buildium;

  useEffect(() => {
    setBuildiumClientId(settings.clientId || "");
    setBuildiumClientSecret(settings.clientSecret || "");
  }, [settings.clientId, settings.clientSecret]);

  return (
    <SettingsCard
      title="Buildium Integration"
      editMode={editMode}
      setEditMode={setEditMode}
      onSave={() => {
        if (
          settings.clientId !== buildiumClientId ||
          settings.clientSecret !== buildiumClientSecret
        )
          updateSettings({ buildiumClientId, buildiumClientSecret });
      }}
    >
      <SettingsItem
        title="Client ID"
        value={buildiumClientId}
        editMode={editMode}
        onChange={setBuildiumClientId}
      />
      <div className="my-6 border-b border-alpha-40" />
      <SettingsItem
        title="Client Secret Setting"
        value={buildiumClientSecret}
        editMode={editMode}
        onChange={setBuildiumClientSecret}
      />
    </SettingsCard>
  );
};
